
<p-toast></p-toast>
<div class="relative min-h-full">
  <p-menubar *ngIf="showMenu" [model]="items">
    <ng-container *ngIf="auth.isAuthenticated$ | async; else loggedOut">
      <p-button (click)="auth.logout({ logoutParams: { returnTo: document.location.origin } })" label="Log out"></p-button>
    </ng-container>
    <ng-template #loggedOut>
      <p-button (click)="auth.loginWithRedirect()" label="Log in"></p-button>
    </ng-template>
  </p-menubar>
  <router-outlet></router-outlet>
  <div class="sticky bottom-0 z-5 ml-auto p-1 col-3 col-offset-9 md:col-1 md:col-offset-11 bg-primary-reverse border-round border-1">
      <label for="darkMode">Dark </label>
      <p-inputSwitch [(ngModel)]="darkMode" inputId="darkMode" (click)="changeStyle()" styleClass="block m-auto"></p-inputSwitch>
  </div>
</div>